module.exports = require('./dist/quill');
